import React from 'react'
import Img from 'gatsby-image'
import { navigate } from 'gatsby'

import {
  Card,
  CardActions,
  Grid,
  Typography,
  CardActionArea,
  CardContent,
} from '@material-ui/core'

import useStyles from './styles'

const CardComponent = ({ data, textoBoton }) => {
  const {
    cardRoot,
    cardContent,
    cardTitle,
    cardButton,
    cardInfoWrapper,
    cardInfo,
    image,
    blogTitle,
  } = useStyles()
  const { titulo, slug, fecha, info, imagen, tipo } = data

  const isBlog = tipo === 'blog'

  return (
    <Card className={cardRoot} elevation={0}>
      <CardContent className={cardContent}>
        {!isBlog && (
          <Typography gutterBottom className={cardTitle} noWrap>
            {titulo}
          </Typography>
        )}
      </CardContent>
      <Grid container className={cardInfoWrapper}>
        <Grid item xs className={cardInfo}>
          <Typography noWrap component="span">
            {isBlog ? `por: ${info}` : info}
          </Typography>
        </Grid>
        <Grid item xs className={cardInfo}>
          <Typography noWrap component="span">
            {fecha}
          </Typography>
        </Grid>
      </Grid>
      <CardActionArea onClick={() => navigate(`/blog/${slug}`)}>
        <Img fluid={imagen.fluid} className={image} />
        {isBlog && (
          <div className={blogTitle}>
            <Typography component="span" noWrap>
              {titulo}
            </Typography>
          </div>
        )}
      </CardActionArea>
      <CardActions className={cardButton}>
        <Typography component="span" onClick={() => navigate(`/blog/${slug}`)}>
          {textoBoton}
        </Typography>
      </CardActions>
    </Card>
  )
}

export default CardComponent
